import "./styles/widget.css"
import { autoInitFromScriptTag, BppSearch } from "./init"

window.BppSearch = BppSearch
autoInitFromScriptTag()

export { BppSearch }
